import { useDoctorSelectionContext } from '@context/DoctorSelection';
import {
  FocusableComponentLayout,
  FocusContext,
  useFocusable
} from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';

import { DOCTOR_SELECTION_VIEW } from '../../focusKey';
import DoctorListItem from '../DoctorListItem';
import QuickMatching from '../QuickMatching';

import * as styles from './styles';
import { MedicalTypeEnum } from '@api/GoodocAPI';

const DoctorList = () => {
  const {
    doctors,
    setItemFocus,
    scrollRef,
    scrollToItem,
    setIsDetailVisible,
    untactDepartment
  } = useDoctorSelectionContext();

  const { ref: focusRef } = useFocusable({ focusKey: DOCTOR_SELECTION_VIEW });

  useEffect(() => {
    setItemFocus();
  }, [setItemFocus]);

  useEffect(() => {
    setIsDetailVisible(false);
  }, [setIsDetailVisible]);

  return (
    <FocusContext.Provider value={DOCTOR_SELECTION_VIEW}>
      <div ref={focusRef} css={styles.container}>
        <div ref={scrollRef} css={styles.scrollContainer}>
          {untactDepartment?.type === MedicalTypeEnum.Medicine && (
            <QuickMatching
              onFocus={(layout: FocusableComponentLayout) => scrollToItem(-1, layout)}
            />
          )}
          {doctors?.map((doctor, index) => (
            <DoctorListItem key={index} index={index} doctor={doctor} />
          ))}
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default DoctorList;
